import { StrictMode } from 'react'
import './i18n'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { redirectToCanonicalHost, shouldRedirectToCanonicalHost } from '@/lib/canonicalHost'

// www.koreacarers.com 으로 들어온 경우 대표 주소로 넘기고 앱은 그리지 않습니다.
if (shouldRedirectToCanonicalHost()) {
  redirectToCanonicalHost()
} else {
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
}
